export function getLinkToCreativeSet(originalLink: string): string {
  const chunks = originalLink.split('#');
  // If same page, just change the hash
  if (window.location.href.startsWith(chunks[0])) {
    return `#${chunks[1]}`;
  }
  return originalLink;
}

export function downloadLink(link: string): void {
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = link;
  document.body.appendChild(a);
  a.click();
}
